/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const containerStyle = {
  container: {
    paddingInline: "1rem",
    margin: "0 auto",
  },
  containerXs: {
    maxWidth: "45rem", // 720px
  },
  containerSm: {
    maxWidth: "55rem", // 880px
  },
  containerMd: {
    maxWidth: "69rem", // 1104px
  },
  containerLg: {
    maxWidth: "81rem", // 1296px
  },
  containerXl: {
    maxWidth: "90rem", // 1440px
  },
  paddingBlock: {
    paddingBlock: "2rem",
  },
};

export default containerStyle;
